// extracted by mini-css-extract-plugin
export default {"heading":"_2ixzOjkxxSBdE7Apa0vIeu","text":"_9NoXp5I7Hj2Yd7q9KAQyd","row":"_2H56ka0xB8QV5xtTY4Rt5_"};